var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-container"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-wrapper"},[_c('img',{staticClass:"loading-logo",attrs:{"src":require("@/assets/img/logo/loading.svg"),"alt":"loading"}})])
}]

export { render, staticRenderFns }